<template>
<span>
    <text-link @click="createTestCase">
        <icon>queue</icon>
        Test case create mode
    </text-link>
    <text-link @click="saveFlow">
        <icon color="error">save</icon>
        Copy and save flow ({{ currentEntry.flow.length }} steps)
    </text-link>
    <text-link v-if="savedEntry.flow" @click="runFlow">
        <icon color="valid">play_circle_outline</icon>
        Run saved flow
    </text-link>
    (<input size="2" v-model="stepsCount">/{{ savedEntry.flow.length }} steps)
</span>
</template>

<script>
import { showNotifier, hideNotifier } from '@/utils/notifier';
import { jsonCopy } from '@/utils/json';
import { copyText } from '@/utils/clipboard';
import { qaBus } from '@/utils/qa-bus';

export default {
    data () {
        return {
            creatingTestCase: false,
            stepsCount: 0,
        };
    },
    mounted () {
        let saveFlow = entry => {
            this.savedEntry = entry;
            this.runFlow();
        };
        window.__odrFlow = saveFlow;
        window.__odrTest = (testCase) => {
            saveFlow(testCase.entry);
        };

        qaBus.$on('runFlow', saveFlow);
        this.stepsCount = this.savedEntry.flow.length;
    },
    computed: {
        currentEntry () {
            return {
                config: {
                    apiUrl: this.$root.appConfig.apiUrl,
                },
                flow: this.$store.state.flow.history.map(entry => {
                    let data = jsonCopy(entry.data || {});
                    delete data.stateId;
                    if (data.initParams && data.initParams.authToken) {
                        delete data.initParams.authToken;
                    }
                    return data;
                }),
            };
        },
        savedEntry: {
            get () {
                return this.$store.state.local.flowEntry || { flow: [] };
            },
            set (value) {
                this.$store.commit('local/SET', { key: 'flowEntry', value });
                this.stepsCount = value.flow.length;
            },
        },
    },
    watch: {
        creatingTestCase () {
            if (this.creatingTestCase) {
                document.body.className += ' odr-g-widget-kangaroo-qa';
                document.addEventListener('click', this.handler, true);
            } else {
                document.body.className = document.body.className.split(' odr-g-widget-kangaroo-qa').join();
                document.removeEventListener('click', this.handler, true);
            }
        },
    },
    methods: {
        handler (event) {
            let target = event.target.getAttribute('data-qa') ? event.target : event.target.closest('[data-qa]');
            if (!target) {
                return;
            }

            event.stopPropagation();
            event.preventDefault();

            let dataQa = target.getAttribute('data-qa');

            if (window.confirm(`test flow created for "${dataQa}" element, it's ok?`)) {
                this.createTest(dataQa);
                this.creatingTestCase = false;
            }
        },

        createTestCase () {
            this.creatingTestCase = !this.creatingTestCase;
        },
        runFlow () {
            this.$root.appConfig.update(this.savedEntry.config);
            let history = jsonCopy(this.savedEntry.flow);
            this.$store.commit('flow/RESET_HISTORY');

            let shiftFlow = step => {
                if (history.length && this.savedEntry.flow.length - this.stepsCount < history.length) {
                    let data = history.shift();

                    if (step.questions) {
                        step.questions.forEach(question => {
                            data.answers.forEach(answer => {
                                if (question.id === answer.id) {
                                    this.$store.commit('flow/SET_QUESTION_VALUE', { question, value: answer.value });
                                }
                            });
                        });
                    }

                    this.$store.dispatch('flow/FETCH', {
                        data: {
                            ...data,
                            stateId: step.stateId,
                            ...(data.initParams ? {
                                initParams: {
                                    ...data.initParams,
                                    ...(window.__odrDebugEmail ? { _debugEmail: window.__odrDebugEmail } : {}),
                                },
                            } : {}),
                        },
                        callback: shiftFlow,
                        fill: history.length > 0,
                        appConfig: this.$root.appConfig,
                    });
                }
            };

            this.$root.appConfig.mainMenuHook(() => {
                shiftFlow({});
            }, this.$root.appConfig);
        },
        createTest (dataQa) {
            let name = window.prompt('Enter test\'s name:');
            let record = window.prompt('Paste here puppeteer-record\'s entry:');

            if (record) {
                record = record.split('(async () => {').join('');
                record = record.split("const puppeteer = require('puppeteer');").join('');
                record = record.split('const browser = await puppeteer.launch()').join('');
                record = record.split('const page = await browser.newPage()').join('');
                record = record.split('await browser.close()').join('');
                record = record.split('})()').join('');
                record = record.split('await').join('; await');
                record = `record: async (page) => {
                    ${record}
                },`;
            }

            let text = `window.__odrTest({name: "${name}", ${record} qa: "${dataQa}", location: "${window.location.href}", entry: ${JSON.stringify(this.currentEntry)}})`;
            copyText(text);

            showNotifier({
                stateId: `general:${this.$root.id}`,
                icon: 'warning',
                title: `Test case: <pre style="font-size: 4px; white-space: pre-wrap; word-break: break-all;">${text}<pre/>`,
                buttons: [
                    {
                        title: 'Close',
                        handler: () => {
                            hideNotifier(`general:${this.$root.id}`);
                        },
                    },
                    {
                        title: 'Copy to clipboard',
                        handler: () => {
                            copyText(text);
                            hideNotifier(`general:${this.$root.id}`);
                        },
                    },
                ],
            });
        },
        saveFlow () {
            copyText(`window.__odrFlow(${JSON.stringify(this.currentEntry)});`);
            this.savedEntry = jsonCopy(this.currentEntry);

            showNotifier({
                stateId: `general:${this.$root.id}`,
                icon: 'warning',
                title: 'Flow copied to clipboard',
                autoHide: true,
                buttons: [
                    {
                        title: 'close',
                        handler: () => {
                            hideNotifier(`general:${this.$root.id}`);
                        },
                    },
                ],
            });
        },
    },
    components: {
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
        'text-link': require('@clearwave/odoro-markup/lib/vue/text-link.vue').default,

    },
};
</script>
